import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Favorites from './Favorites';

const PageContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
`;

const BackButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--card-bg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`;

const Title = styled.h1`
  background: linear-gradient(45deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2rem;
  font-weight: 900;
`;

const FavoritesPage: React.FC = () => {
  return (
    <PageContainer>
      <Header>
        <BackButton to="/">
          ← Voltar
        </BackButton>
        <Title>❤️ Suas Favoritas</Title>
      </Header>
      
      <Favorites />
    </PageContainer>
  );
};

export default FavoritesPage;